module.exports = __webpack_public_path__ + "img/배려심.f6326f3a.svg";